import { Button } from "antd"
import { useNavigate, useLocation } from "react-router-dom"
import { Container } from "../../components"
import { useTheme } from "styled-components"
import shippingGif from '../../images/shippingplab-gif.gif'


export function OrderConfirmationPage() {
    const navigate = useNavigate()
    const location = useLocation()
    // Get orderId from state passed via navigate
    const orderId = location.state?.orderId
    const theme = useTheme()
    return (
        <Container>
            <div
                style={{
                    maxWidth: 500,
                    margin: "3em auto",
                    background: "#f6faff",
                    border: "1px solid #e6f4ff",
                    borderRadius: 12,
                    boxShadow: "0 2px 8px rgba(22,119,255,0.08)",
                    padding: "2em",
                    textAlign: "center",
                }}
            >
                <h2 style={{ color: theme.primary, marginBottom: 16 }}>Order Submitted Successfully!</h2>
                <p style={{ fontSize: 16, marginBottom: 24 }}>
                    Thank you for your order.
                    {orderId && (
                        <>
                            <br />
                            Your order ID is <b>{orderId}</b>.
                        </>
                    )}
                    <br />
                    You will receive a confirmation email shortly.
                </p>
                
                {/* Shipping GIF */}
                <div style={{ marginBottom: 24 }}>
                    <img 
                        src={shippingGif} 
                        alt="Shipping Animation" 
                        style={{ 
                            maxWidth: '350px', 
                            width: '100%', 
                            height: 'auto',
                            borderRadius: '8px'
                        }} 
                    />
                </div>
                
                {/* Shipping Instructions */}
                <div style={{ 
                    backgroundColor: '#fff7e6', 
                    border: '1px solid #ffd591', 
                    borderRadius: '8px', 
                    padding: '16px', 
                    marginBottom: '24px',
                    textAlign: 'left'
                }}>
                    <h3 style={{ color: theme.primary, marginBottom: '12px', fontSize: '16px' }}>
                        📦 Next Steps - Sample Shipping
                    </h3>
                    <p style={{ margin: '0 0 8px 0', fontSize: '14px', lineHeight: '1.5' }}>
                        1. Prepare your samples according to the instructions provided
                    </p>
                    <p style={{ margin: '0 0 8px 0', fontSize: '14px', lineHeight: '1.5' }}>
                        2. Ship your samples using your preferred delivery method
                    </p>
                    <p style={{ margin: '0', fontSize: '14px', lineHeight: '1.5' }}>
                        3. <strong>Important:</strong> Once you've sent your samples, please check the "Shipping" box on the "My Orders" page to notify us that your samples are on the way
                    </p>
                </div>

                <Button type="primary" onClick={() => navigate("/myspace/myorders")}>
                    Go to My Orders
                </Button>
            </div>
        </Container>
    )
}
